import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function GraphIcon({
	width = 20,
	height = 16,
	active = false,
	'aria-label': ariaLabel = 'Graph',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const g = customIconColor?.glyphColor ?? (active ? customIconColor?.glyphColor : '#353535');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 16"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				d="M0.000646412 0.481345C0.000646412 0.216101 0.210355 0 0.469498 0C0.727858 0 0.938349 0.215297 0.938349 0.481345V15.0373H19.5311C19.7903 15.0373 20 15.2526 20 15.5187C20 15.7839 19.7903 16 19.5311 16H0.468852C0.209709 16 0 15.7847 0 15.5187V0.481205L0.000646412 0.481345ZM15.6621 1.94014C15.7403 1.86073 15.8471 1.80916 15.9659 1.80343L18.9777 1.63561C19.2353 1.62251 19.4553 1.82553 19.4681 2.09076C19.4697 2.11122 19.4689 2.13087 19.4673 2.15134H19.4681L19.2321 5.27042C19.2233 5.39076 19.1731 5.49637 19.0965 5.57496C19.0271 5.64618 18.9426 5.68138 18.8445 5.67974C18.7473 5.67811 18.6635 5.64209 18.595 5.57005L17.4978 4.40596L13.1655 8.85372C12.9821 9.042 12.6862 9.042 12.5028 8.85372L9.74539 6.02279L3.07137 12.8746C2.88798 13.0629 2.59214 13.0629 2.40875 12.8746C2.22536 12.6864 2.22536 12.3826 2.40875 12.1944L9.41362 5.00283C9.59702 4.81455 9.89285 4.81455 10.0762 5.00283L12.8337 7.83376L16.8452 3.71538L15.6539 2.45142C15.5199 2.30898 15.5231 2.08139 15.6603 1.94306L15.6621 1.94014Z"
				fill={g}
				fillOpacity={active ? 1 : 0.48}
			/>
		</svg>
	);
}
